import { render, staticRenderFns } from "./bin-delete.vue?vue&type=template&id=08c9535e&"
import script from "./bin-delete.vue?vue&type=script&lang=js&"
export * from "./bin-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports